import React from 'react';
import { config } from '../../../services/config';
import { useIntl } from 'react-intl';
import { configMessages } from '../../../lang/messages';
import { groupBySuaNamePnid } from './utils';
import Page from './Page';

interface Props {
  assemblyGeneral: any;
  assemblyComponents: any;
  assemblyList: any;
  exportDate: string;
  exportTimestamp: number;
  pageNumber: number;
  totalPageNumber: number;
  time?: number;
}

const SchemaPID = ({
  assemblyGeneral,
  assemblyComponents,
  assemblyList,
  exportDate,
  exportTimestamp,
  pageNumber,
  totalPageNumber,
  time
}: Props) => {
  const intl = useIntl();

  // retourne un tableau d'objet avec le nom de l'assembly et le nombre de fois qu'il apparait
  let countByAssembly = groupBySuaNamePnid(assemblyComponents, 'assembly');

  return (
    <Page isLastpage={totalPageNumber === pageNumber}>
      <div className="f-col f-grow">
        <div className="border-bottom py-2">
          <div className="f-row f1-between f2-center">
            <div>
              <span>{intl.formatMessage(configMessages.PID)}</span>
              <span className="px-2">&#124;</span>
              <span className="font-regular">{assemblyGeneral.name}</span>
            </div>
            <div>{exportDate}</div>
          </div>
        </div>
        <div
          className="f-full f-center mt-1"
          style={{
            height: 400,
            backgroundImage:
              'url(' +
              config.BlobURL +
              '/single-use-configurator/assemblies/thumbnail/' +
              assemblyGeneral.id +
              '_UO_Annotated_PID' +
              '.png?nocache=' +
              exportTimestamp +
              ')',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain'
          }}></div>
        <div className="col-count-5 pt-1">
          {countByAssembly.map((assembly: any, index: any) => {
            return (
              <div key={assembly.name + index} className="f-row f2-center gap-2">
                <span>{`${time > 0 ? index + 1 + 20 * time : index + 1}.`}</span>
                <span className="max-1-lines-visible">{assembly.name}</span>
                <span> {`(${assembly.count})`}</span>
              </div>
            );
          })}
        </div>

        {/* <div style={{ width: '100%', height: 100, display: 'flex', flexFlow: 'column wrap', marginTop: 20 }}>
        {assemblies
          .map((assembly, index) => {
            return (<div key={assembly.general.id + index}>
              <span>{time > 0 ? index + 1 + 20 * time : index + 1}</span>
              <span className='bold'> {assembly.general.name}</span>
            </div>);
          })}
      </div> */}
      </div>

      <div className="f-row f1-end gap-2 mt-3" style={{ fontSize: 13 }}>
        <div>{`Page ${pageNumber}/${totalPageNumber}`}</div>
      </div>
    </Page>
  );
};

export default SchemaPID;
